import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d07cc32e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "decorate-none left-list" };
const _hoisted_2 = ["value"];
const _hoisted_3 = ["onClick"];
export default /*#__PURE__*/ _defineComponent({
    props: {
        width: null,
        language: null,
        selectionList: null
    },
    emits: ["click"],
    setup(__props, { emit }) {
        const props = __props;
        const onClick = (value) => {
            emit('click', value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("ul", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.selectionList, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: item.value,
                            value: item.value
                        }, [
                            _createElementVNode("button", {
                                class: "btn",
                                onClick: ($event) => (onClick(item.value))
                            }, _toDisplayString(item.title), 9, _hoisted_3)
                        ], 8, _hoisted_2));
                    }), 128))
                ])
            ]));
        };
    }
});
